import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultTriggeredPopup: BlockMetadata = {
  id: 'default',
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [],
  theme: EThemes.ROYAL_BLAST,
  component: () => null
};

export const triggeredPopupsDesigns = {
  defaultTriggeredPopup
};

export const triggeredPopupsDesignsByTheme: Record<EThemes, BlockMetadata[]> =
  Object.values(triggeredPopupsDesigns).reduce(
    (acc, design) => {
      if (!acc[design.theme]) {
        acc[design.theme] = [];
      }
      acc[design.theme].push(design);
      return acc;
    },
    {} as Record<EThemes, BlockMetadata[]>
  );
